import type { IntlShape } from 'react-intl';

export const getTurnTrackingPartiesNames: (
  intl: IntlShape,
) => Record<string, string> = (intl) => {
  return {
    Internal: intl.formatMessage({
      id: 'TurnTrackingPanel.internalParty',
      defaultMessage: 'Internal',
      description: 'Name for internal party in turn tracking',
    }),
    External: intl.formatMessage({
      id: 'TurnTrackingPanel.externalParty',
      defaultMessage: 'External',
      description: 'Name for external party in turn tracking',
    }),
  };
};
